/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a box-and-whisker plot from grouped data — compare distributions, no sign-up.`)
};

const es_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un diagrama de caja y bigotes a partir de datos agrupados — compara distribuciones, sin registro.`)
};

const de_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie einen Box-Plot (Box-Whisker-Diagramm) aus gruppierten Daten — vergleichen Sie Verteilungen, keine Anmeldung erforderlich.`)
};

const nl_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een box-and-whiskerplot van gegroepeerde data — vergelijk verdelingen, geen registratie nodig.`)
};

const fr_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez une boîte à moustaches à partir de données groupées — comparez les distributions, sans inscription.`)
};

const it_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un box plot (a scatola e baffi) da dati raggruppati — confronta le distribuzioni, senza registrazione.`)
};

const pt_br2_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um diagrama de caixa (boxplot) a partir de dados agrupados — compare distribuições, sem cadastro.`)
};

const pt_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie um diagrama de extremos e quartis a partir de dados agrupados — compare distribuições, sem registo.`)
};

const ja_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループ化されたデータから箱ひげ図を作成します — 分布を比較、登録不要。`)
};

const zh_box_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`根据分组数据创建箱线图（箱须图）——比较分布情况，无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const box_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.box_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("box_tool_description", locale)
	if (locale === "en") return en_box_tool_description(inputs)
	if (locale === "es") return es_box_tool_description(inputs)
	if (locale === "de") return de_box_tool_description(inputs)
	if (locale === "nl") return nl_box_tool_description(inputs)
	if (locale === "fr") return fr_box_tool_description(inputs)
	if (locale === "it") return it_box_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_box_tool_description(inputs)
	if (locale === "pt") return pt_box_tool_description(inputs)
	if (locale === "ja") return ja_box_tool_description(inputs)
	return zh_box_tool_description(inputs)
};